import { Component, EventEmitter, Input, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import { ServiceTypeSelectStore } from './service-type-select.store';
import { FormGroup } from '@angular/forms';
import { ServiceTypeGridItemObject } from '@it2go/types';
import { startWith, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import config from '../../../../../config/config';
import { FilterBuilder } from '../../../../content/helper/filter.builder';
import { SubscriptionComponent } from '../../../../shared/helpers/subscription.component';
import { SelectInputComponent } from '../../../../../components/kit/input/select-input/select-input.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-service-type-select',
    templateUrl: 'service-type-select.component.html',
    styleUrls: ['service-type-select.component.scss'],
    providers: [ServiceTypeSelectStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SelectInputComponent,
        AsyncPipe,
    ],
})
export class ServiceTypeSelectComponent extends SubscriptionComponent {

    protected readonly store = inject(ServiceTypeSelectStore);

    @Input() form!: FormGroup;
    @Input() id = 'serviceTypeId';
    @Input() label = 'service.serviceType.label';
    @Input() disabled: boolean = false;

    @Output() collectionSelected = new EventEmitter<ServiceTypeGridItemObject>();

    protected searchSubject = new Subject<string>();

    constructor() {
        super();
        this.fetchItems();
        this.subs.push(
            this.searchSubject
                .pipe(debounceTime(config.debounceTime))
                .subscribe((search) => this.fetchItems(search)),
        );
    }

    public async ngOnInit(): Promise<void> {
        this.subs.push(
            this.form.controls[this.id].valueChanges
                .pipe(startWith(null))
                .subscribe(async (itemId: string | null) => {
                    const id = itemId || this.form.value[this.id];
                    if (id && itemId != this.form.value[this.id]) {
                        const items = await this.store.get(this.store.serviceTypes$);
                        if (items.length) {
                            const item = items.find((it: ServiceTypeGridItemObject) => it.id == id);
                            if (item) this.collectionSelected.emit(item);
                        } else {
                            this.store.api.getServiceTypes(FilterBuilder.singleItem({ id }));
                        }
                    }
                }),
        );
    }

    public filter(search: string): void {
        this.searchSubject.next(search);
    }

    private async fetchItems(search: string | null = null) {
        this.store.api.getServiceTypes(FilterBuilder.filter({
            limit: 100,
            search,
            sort: { column: 'name', direction: 'ASC' },
        }));
    }

}
